import AccountStatementsScreen from 'features/statementsAndForms/screens/AccountStatements/AccountStatementsScreen';
import React from 'react';

export default function AccountSelectionScreenPage() {
  return <AccountStatementsScreen />;
}
